import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const config = (user) => ({
  headers: { Authorization: `Bearer ${user.token}` },
  params: { cache_bust: new Date().getTime() },
});

// Los tres dejan pasar el error de axios tal cual: quien llama necesita
// `error.response.status` y `error.response.data.detail` para explicar un 409
// (el grupo no subió el anteproyecto) o un 401 en pantalla.

// Estado del anteproyecto (aprobado, última revisión) y el historial de
// devoluciones. Lo ven los integrantes del grupo, su tutor, su revisor y admin.
export const getPreReportFeedback = async (user, groupId) => {
  const response = await axios.get(
    `${BASE_URL}/groups/${groupId}/initial-project/feedback`,
    config(user)
  );
  return response.data;
};

// Registra una devolución (no aprueba) y se la manda al grupo por mail.
export const sendPreReportFeedback = async (user, groupId, message) => {
  const response = await axios.post(
    `${BASE_URL}/groups/${groupId}/initial-project/feedback`,
    { message },
    config(user)
  );
  return response.data;
};

// Aprueba el anteproyecto, con mensaje opcional, y avisa al grupo por mail.
export const approvePreReport = async (user, groupId, message) => {
  const response = await axios.post(
    `${BASE_URL}/groups/${groupId}/initial-project/approval`,
    { message: message || null },
    config(user)
  );
  return response.data;
};
